import { graphql } from "relay-runtime"

export const chCheckPartnerPortalEligibilityMutation = graphql`
  mutation chCheckPartnerPortalEligibilityMutation($input: Ch_checkPartnerPortalEligibilityInput!) {
    ch_checkPartnerPortalEligibility(input: $input) {
      checkPartnerPortalEligibilityOutput {
        isEligible
        nearbyCareProviderIds
        closestCareProvider {
          businessName
          title
          firstName
          lastName
          distanceKm
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
